import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  HeroRoot,
  Container,
} from './ProductDetailHero.styles'

export type RecipeType = 'venison' | 'chicken' | 'lamb' | 'duck' | 'beef' | 'turkey'

type ProductHeroProps = {
    children: JSX.Element[]
    recipe?: RecipeType
}

export const ProductDetailHero = ({ children, recipe }: ProductHeroProps) => {
  const { t } = useTranslation()

  return (
    <HeroRoot color={recipe}>
      <Container>
        {children}
      </Container>
    </HeroRoot>
  )
}

ProductDetailHero.displayName = 'RecipeDetailHero'